import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { MessageServiceService } from "src/app/services/message-service.service";
import { CallCenterService } from "src/app/services/call-center.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { Constants } from "src/app/app.constants";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { CalendarUtilityService } from "src/app/services/calendar-utility.service";
import { SelectItem, Paginator } from "primeng";
import { UserprivilegeService } from "src/app/services/userprivilege.service";
import { CommonService } from "src/app/services/common.service";
import { NavigationEnd, Router, ActivatedRoute } from "@angular/router";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-manage-package-leads",
  templateUrl: "./manage-package-leads.component.html",
  styleUrls: ["./manage-package-leads.component.scss"],
})
export class ManagePackageLeadsComponent implements OnInit {
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
  };
  @ViewChild("updatePackageLeadCallStatus", { static: false })
  updatePackageLeadCallStatus: TemplateRef<any>;
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;
  UpdateModalRef: BsModalRef;
  columns = [];
  isLoading: boolean = false;
  dateConfig: Partial<BsDatepickerConfig>;
  //global filters
  maxDate: Date = new Date();
  recordsPerPage: number = 50;
  createForm: FormGroup;
  selectedFromDate: any = new Date(); //"2020-12-24 11:57:12"
  selectedToDate: any = new Date();
  ClinicNameData: any = [];
  filterClinicName = "";
  bussinessUnitId: string;
  //filterClinicId:string;
  seletedClinicName: string;

  constructor(
    private messageService: MessageServiceService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private callcenterservice: CallCenterService,
    private userPrivilegesService: UserprivilegeService,
    private calendarService: CalendarUtilityService,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {
    this.columns = [
      {
        field: "callDateTime",
        header: "Call Date Time",
        display: "table-cell",
      },
      { field: "patientName", header: "Name", display: "table-cell" },
      { field: "mobile", header: "Mobile", display: "table-cell" },
      { field: "email", header: "Email", display: "table-cell" },
      {
        field: "clinicName",
        header: "Clinic / Hosipital",
        display: "table-cell",
      },
      { field: "edd", header: "EDD", display: "table-cell" },
      { field: "callStatus", header: "Call Status", display: "table-cell" },
      { field: "remarks", header: "Remarks", display: "table-cell" },
    ];
  //  const edd = formatDate(`${"edd"}`.replaceFunction('/','-'),'full','es-CO');


    this.dateConfig = Object.assign(
      {},
      { containerClass: "theme-orange", dateInputFormat: "DD/MM/YYYY" }
    );
    this.route.queryParamMap.subscribe((param) => {
      if (param.get("filterClinicId")) {
        this.filterClinicName = param.get("filterClinicId");
      }
    });
  }

  hasExportPrivilege: boolean = false;
  hasAddEditPrivilege: boolean = false;
  userDetails: any;
  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));
    //console.log(this.userDetails.bussinessUnitId,"user")
    this.bussinessUnitId = this.userDetails.bussinessUnitId;
    this.maxDate.setDate(this.maxDate.getDate());
    this.selectedFromDate = this.selectedToDate = this.maxDate;
    this.createForm = this.formBuilder.group({
      Status: ["", [Validators.required]],
      Remarks: ["", [Validators.required]],
    });
    this.getPackageEnquiryClinics();
    setTimeout(() => {
      if (
        this.userPrivilegesService.hasActivateDeActivatePrivilege(
          Constants.ManagePackageLeads
        )
      ) {
        this.hasAddEditPrivilege = true;
      }
      if (
        this.userPrivilegesService.hasAddEditPrivilege(
          Constants.ManagePackageLeads
        )
      ) {
        this.hasExportPrivilege = true;
      }
    }, 500);
  }

  getPackageEnquiryClinics() {
    this.ClinicNameData = [];
    this.packageEnquiriesData = null;
    this.isLoading = true;
    this.callcenterservice.getPackageEnquiryHMSClinics().subscribe(
      (res: any) => {
        console.log("clinic/hospital",res);
        if (res && res) {
          this.ClinicNameData = [
            ...new Map(
              res.map((item) => [item["id"], item])
            ).values(),
          ];
          this.getPackageEnquiryData();
        } else {
          this.ClinicNameData = [];
          this.messageService.showErrorMessage("No Data Found");
        }
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      },
      (error) => {
        this.isLoading = false;
        this.messageService.showErrorMessage(
          "Unable to retrieve clinics data from server"
        );
      }
    );
  }
  // private convertToDate(dateString: string): Date | null {
  //   if (!dateString) return null; // Handle null or undefined input
  
  //   const [day, month, yearAndTime] = dateString.split('-');
  //   const [year, time] = yearAndTime.split(' ');
  
  //   if (day && month && year) {
  //     // Construct a valid date string in ISO 8601 format
  //     const isoDate = `${year}-${month}-${day}T${time || '00:00:00'}`;
  //     return new Date(isoDate);
  //   }
  
  //   return null; // Return null if parsing fails
  // }
  

  packageEnquiriesData = [];
  totalRecords: number = 0; 
  getPackageEnquiryData() {
    this.packageEnquiriesData = [];
    this.isLoading = true; 
    let payload = {
      rowsCount: this.recordsPerPage,
      pageNo: this.PageNoChangeValue ? this.PageNoChangeValue : 0,
      fromDate: this.selectedFromDate ? this.selectedFromDate : null,
      toDate: this.selectedToDate ? this.selectedToDate : null,
      clinicId:  this.filterClinicName ? this.filterClinicName : 0,
    };
    this.callcenterservice.getPackageEnquiryData(payload).subscribe(
      (res: any) => {
        console.log("package data", res);
        if (res && res.response != null && res.response != "") {
          // Transforming data
          this.packageEnquiriesData = res.response["packageEnquiries"]
          // .map((item: any) => {
          //   return {
          //     ...item,
          //     edd: this.convertToDate(item.edd), // Convert `edd` to Date
          //     callDateTime: new Date(item.callDateTime), // Convert `callDateTime` to Date
          //   };
         // });
          this.totalRecords = res.response["totalRecords"];
          this.getAllAppointmentStatus();
        } else {
          this.packageEnquiriesData = null;
          this.messageService.showErrorMessage("No records found");
        }
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      },
      (error) => {
        this.isLoading = false;
        this.messageService.showErrorMessage(
          "Unable to retrieve package leads data from server"
        );
      }
    );
  }
  
  // // Helper function to convert the custom date string to a JavaScript Date object
  // private convertToDate(dateString: string): Date | null {
  //   if (!dateString) return null; // Handle null or undefined
  //   const [day, month, yearAndTime] = dateString.split('-');
  //   const [year, time] = yearAndTime.split(' ');
  //   return new Date(`${year}-${month}-${day}T${time || '00:00:00'}`);
  // }
  

  onClinicChange(event: Event) {
    debugger;
  const selectedValue = (event.target as HTMLSelectElement).value;
 this.filterClinicName = selectedValue;
  // Do something with the selected clinic
  // e.g., update other form fields or fetch related data
}


  appointmentStatusData: any[];
  appointmentStatusCradleData: any[];
  getAllAppointmentStatus() {
    let BU = this.userDetails.bussinessUnitName.split(",");
    let filterBU = "Clinic";
    if (
      BU.includes("Cradle") &&
      !BU.includes("Fertility") &&
      !BU.includes("Spectra") &&
      !BU.includes("Clinic") &&
      !BU.includes("Diagnostics")
    ) {
      this.isLoading = true;
      let callType = 5;
      console.log(callType);
      this.commonService.getAllAppointmentStatus(callType).subscribe(
        (res: any) => {
          console.log("appointmentStatusData",res);
          if (res.response.length > 0) {
            this.appointmentStatusCradleData = res.response;
            this.appointmentStatusData = res.response;
          }
          this.isLoading = false;
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to retrieve call status data from server "
          );
        }
      );
    } else if (
      BU.includes("Cradle") &&
      (BU.includes("Fertility") ||
        BU.includes("Spectra") ||
        BU.includes("Clinic"))
    ) {
      this.isLoading = true;
      this.commonService.getAllAppointmentStatus(5).subscribe(
        (res: any) => {
          if (res.response.length > 0) {
            this.appointmentStatusCradleData = res.response;
          }
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to retrieve call status data from server "
          );
        }
      );
      this.commonService.getAllAppointmentStatus(3).subscribe(
        (res: any) => {
          if (res.response.length > 0) {
            let resAppointmentStatusData = res.response;
            const appointmentData = [...this.appointmentStatusCradleData, ...resAppointmentStatusData]
            this.appointmentStatusData = appointmentData;
            console.log(appointmentData, "All")
          }
          this.isLoading = false;
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to retrieve call status data from server "
          );
        }
      );
    }

    else if (!BU.includes("Cradle")) {
      this.isLoading = true;
      let callType = 3;
      this.appointmentStatusData = [];
      this.commonService.getAllAppointmentStatus(callType).subscribe(
        (res: any) => {
          if (res.response.length > 0) {
            this.appointmentStatusData = res.response;
          }
          this.isLoading = false;
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to retrieve call status data from server "
          );
        }
      );

    }
  }

  DispositionId: any;
  getSubDispositionOnId(event) {
    this.DispositionId = event;
  }

  SearchCallLogsData() {
    // if (this.filterClinicName == '') {
    //   this.messageService.showErrorMessage("Please select clinic / hospital.!");
    //   return;
    // }
    this.getPackageEnquiryData();
  }

  resetFilters() {
    this.filterClinicName = "";
    this.selectedFromDate = this.selectedToDate = this.maxDate;
    this.getPackageEnquiryData();
  }

  @ViewChild("topPaginator", { static: false }) topPaginator: Paginator;
  @ViewChild("bottomPaginator", { static: false }) bottomPaginator: Paginator;
  PageNoChangeValue: number = 0;
  paginate(event, paginatorPosition) {
    if (paginatorPosition == "top") {
      this.bottomPaginator._first = this.topPaginator._first;
      this.bottomPaginator.pageLinks = this.topPaginator.pageLinks;
      this.bottomPaginator.rows = this.topPaginator.rows;
      this.bottomPaginator.totalRecords = this.topPaginator.totalRecords;
    } else {
      this.topPaginator._first = this.bottomPaginator._first;
      this.topPaginator.pageLinks = this.bottomPaginator.pageLinks;
      this.topPaginator.rows = this.bottomPaginator.rows;
      this.topPaginator.totalRecords = this.bottomPaginator.totalRecords;
    }
    this.PageNoChangeValue = event.page;
    this.getPackageEnquiryData();
  }

  PackageDetailsRowData: any;
  edit(data) {
    this.PackageDetailsRowData = data;
    this.UpdateModalRef = this.modalService.show(
      this.updatePackageLeadCallStatus,
      Object.assign({}, this.config, {
        class: "gray modal-md modal-dialog-centered",
      })
    );
    this.createForm.setValue({ Status: "", Remarks: data.remarks });
  }

  closeConfirmModal() {
    this.UpdateModalRef.hide();
  }

  onSubmit(formData) {
    let payload = {
      Id: this.PackageDetailsRowData.id,
      Remarks: formData.Remarks,
      CallStatusId: formData.Status,
    };
    this.isLoading = true;
    this.callcenterservice.UpdatePackageEnquiryStatus(payload).subscribe(
      (res: any) => {
        alert('package update');
        console.log("onsubmit",res);
        if (res.isSuccess) {
          this.messageService.showSuccess(
            "Package Enquiry Details Updated Successfully"
          );
          this.UpdateModalRef.hide();
          this.getPackageEnquiryData();
        } else {
          this.messageService.showErrorMessage(
            "Failed to Update Package Enquiry Details..!"
          );
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.messageService.showErrorMessage(
          "Unable to update package details..please try again after some time"
        );
      }
    );
  }
}
